// src/services/serviceFactory.ts
import { IGamificationService, IMealService, IUserService } from './interfaces';
import { MealService as ApiMealService } from './api/mealService';
import { UserService as ApiUserService } from './api/userService';
import { GamificationService as ApiGamificationService } from './api/gamificationService';
import { MockMealService } from './mock/mockMealService';
import { MockUserService } from './mock/mockUserService';
import { MockGamificationService } from './mock/mockGamificationService';

export class ServiceFactory {
  private static instance: ServiceFactory;
  private mealService: IMealService;
  private userService: IUserService;
  private gamificationService: IGamificationService;

  private constructor() {
    // Check if we should use mock services based on environment variable
    const useMock = process.env.REACT_APP_USE_MOCK_SERVICES === 'true';

    this.mealService = useMock
      ? new MockMealService()
      : ApiMealService.getInstance();
    this.userService = useMock
      ? new MockUserService()
      : ApiUserService.getInstance();
    this.gamificationService = useMock
      ? new MockGamificationService()
      : ApiGamificationService.getInstance();
  }

  static getInstance(): ServiceFactory {
    if (!ServiceFactory.instance) {
      ServiceFactory.instance = new ServiceFactory();
    }
    return ServiceFactory.instance;
  }

  getMealService(): IMealService {
    return this.mealService;
  }

  getUserService(): IUserService {
    return this.userService;
  }

  getGamificationService(): IGamificationService {
    return this.gamificationService;
  }
}
